import { SIGN_UP_COMPANY, SIGN_UP_COMPANY_ERROR, SIGN_UP_COMPANY_SUCCESS } from 'constants/ActionTypes';
import { fromJS } from 'immutable';

const initialState = fromJS({
  isSubmitted: false,
  error: null,
});

const companySignUpReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIGN_UP_COMPANY:
      return state.set('isSubmitted', false).set('error', null);
    case SIGN_UP_COMPANY_SUCCESS:
      return state.set('isSubmitted', true);
    case SIGN_UP_COMPANY_ERROR:
      return state.set('error', fromJS(action.error));
    default:
      return state;
  }
};

export default companySignUpReducer;
